import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useCustomerOptions } from '@/hooks/useCustomerOptions';
import type { EntityOptionResponse } from '@/types/entityOption';
import { useSelectLabels } from '@/hooks/useSelectLabels';
export interface CustomerSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onCustomerChange?: (customer: EntityOptionResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  showDetails?: boolean;
  name?: string;
}

export function CustomerSelect({
  label = 'Customer',
  value = '',
  onChange,
  onCustomerChange,
  placeholder,
  disabled,
  className,
  required,
  error,
  showDetails: _showDetails = true,
  name,
}: CustomerSelectProps) {
  const selectLabels = useSelectLabels();
  const { options, loading, getCustomer } = useCustomerOptions();

  const handleChange = (next: string) => {
    onChange?.(next);
    onCustomerChange?.(next ? getCustomer(next) ?? null : null);
  };

  return (
    <div className={className}>
      <SearchableSelect
        label={label}
        name={name}
        required={required}
        error={error}
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder ?? selectLabels.selectCustomer}
        disabled={disabled}
        loading={loading}
        searchPlaceholder={selectLabels.searchCustomers}
        emptyMessage={selectLabels.noCustomers}
      />
    </div>
  );
}
